import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  open = (index = null) => {
    let indicatorTarget = index == null ? this.indicatorTarget : this.indicatorTargets[index]
    let contentTarget = index == null ? this.contentTarget : this.contentTargets[index]

    indicatorTarget.innerHTML = this.iconHtml(index)
    contentTarget.classList.remove('hidden')
  }

  close = (index = null) => {
    let indicatorTarget = index == null ? this.indicatorTarget : this.indicatorTargets[index]
    let contentTarget = index == null ? this.contentTarget : this.contentTargets[index]

    indicatorTarget.innerHTML = this.iconHtml(index)
    contentTarget.classList.add('hidden')
  }

  iconHtml = index => {
    if (index == null) {
      return '<ion-icon name="chevron-forward-outline"></ion-icon>'
    }

    return `<ion-icon name="chevron-forward-outline" data-index=${ index }></ion-icon>`
  }
}
